import script from "./ConnectPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnectPage.vue?vue&type=script&setup=true&lang=js"

import "./ConnectPage.vue?vue&type=style&index=0&id=d965ef76&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d965ef76"]])

export default __exports__